import { Box } from '@mui/material'
import ButtonPanel from './ButtonPanel'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import { useDispatch, useSelector } from 'react-redux'
import { mqttRequest } from '../../common/store/actions/mqtt/actions'
import { getMqttState } from '../../common/store/selectors/mqtt'
import { resetDevices } from '../../common/api/devices/devices'

const ResetSystemButton = () => {
  const dispatch = useDispatch()
  const { isLoading } = useSelector(getMqttState)

  const onClickHandle = () => {
    dispatch(mqttRequest({ topic: 'ALL/cmd', payload: 'rcmd mod:disp,rst' }))
    resetDevices()
  }

  return (
    <ButtonPanel
      variant="contained"
      widthAndHeight={72}
      color="primary"
      onClick={onClickHandle}
      loading={isLoading}
      tooltip="Reset all devices"
    >
      <Box
        sx={{
          position: 'absolute',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          alignItems: 'center',
        }}
      >
        <Box m={4} width="100%" height="100%">
          <RestartAltIcon
            sx={{
              width: '100%',
              height: '100%',
            }}
          />
        </Box>
      </Box>
    </ButtonPanel>
  )
}

export default ResetSystemButton
